const spaceNumber = (number: string | number) => {
  return number.toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
};

const maskNumber = (val: string) => {
  if (!val) return '';
  // The plusSignLength variable is used to remove the plus character from the masked number
  const plusSignLength = val.split('+').length - 1;
  const masked = val.slice(0, -2);
  const unMasked = val.slice(-2);
  return `+${'*'.repeat(masked.length - plusSignLength)}${unMasked}`;
};

export default maskNumber;
